import { useSelector } from 'react-redux'
import RemovableWidgetDiv from './RemovableWidgetDiv'

function RemoveWidgets() {
  const {
    adminToolbox,
    managerToolbox,
    employeeToolbox,
    employeeLayouts,
    managerLayouts,
    adminLayouts,
  } = useSelector((state) => state.addWidget)

  return (
    <div className='d-flex align-items-baseline justify-content-between'>
      <div className='mx-5'>
        <h1 className='mb-2'>Admin</h1>
        {adminToolbox &&
          adminToolbox.map((toolbox) => (
            <RemovableWidgetDiv
              key={toolbox.id}
              toolbox={toolbox}
              toolboxes={adminToolbox}
              layouts={adminLayouts}
              id={1}
            />
          ))}
      </div>
      <div className='mx-5'>
        <h1 className='mb-2'>Manager</h1>
        {managerToolbox &&
          managerToolbox.map((toolbox) => (
            <RemovableWidgetDiv
              key={toolbox.id}
              toolbox={toolbox}
              toolboxes={managerToolbox}
              layouts={managerLayouts}
              id={2}
            />
          ))}
      </div>
      <div className='mx-5'>
        <h1 className='mb-2'>Employee</h1>
        {employeeToolbox &&
          employeeToolbox.map((toolbox) => (
            <RemovableWidgetDiv
              key={toolbox.id}
              toolbox={toolbox}
              toolboxes={employeeToolbox}
              layouts={employeeLayouts}
              id={3}
            />
          ))}
      </div>
    </div>
  )
}

export default RemoveWidgets
